import { Check } from "lucide-react";

export function OrderSection({ num, title, active, done, children }) {
  if (!active) {
    return (
      <div className="opacity-40 pointer-events-none">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-7 h-7 rounded-full bg-gray-200 text-gray-500 text-xs font-bold flex items-center justify-center">{num}</span>
          <h2 className="text-xs sm:text-sm font-bold text-gray-500 uppercase tracking-wide">{title}</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-3 sm:p-5 shadow-sm" data-testid={`step-${num}`}>
      <div className="flex items-center gap-3 mb-3 sm:mb-4">
        <span className={`w-7 h-7 rounded-full text-xs font-bold flex items-center justify-center ${done ? "bg-emerald-500 text-white" : "bg-emerald-100 text-emerald-700"}`}>
          {done ? <Check className="w-4 h-4" /> : num}
        </span>
        <h2 className="text-xs sm:text-sm font-bold text-gray-900 uppercase tracking-wide">{title}</h2>
      </div>
      {children}
    </div>
  );
}
